var _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWStoreEditLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_869_2618)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0022 123.665C96.9528 123.665 123.665 96.9528 123.665 64.0022C123.665 31.0515 96.9528 4.33978 64.0022 4.33978C31.0515 4.33978 4.33978 31.0515 4.33978 64.0022C4.33978 96.9528 31.0515 123.665 64.0022 123.665Z",
    fill: "#1C7C23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0021 4.33978C96.9519 4.33978 123.664 31.0524 123.664 64.0021C123.664 96.9519 96.9519 123.664 64.0021 123.664C31.0524 123.664 4.33978 96.9519 4.33978 64.0021C4.33978 31.0524 31.0524 4.33978 64.0021 4.33978ZM64.0021 0C28.7087 0 0 28.7087 0 64.0021C0 99.2956 28.7087 128.004 64.0021 128.004C99.2956 128.004 128.004 99.2956 128.004 64.0021C128.004 28.7087 99.2913 0 64.0021 0Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0022 123.665C96.9528 123.665 123.665 96.9528 123.665 64.0022C123.665 31.0515 96.9528 4.33978 64.0022 4.33978C31.0515 4.33978 4.33978 31.0515 4.33978 64.0022C4.33978 96.9528 31.0515 123.665 64.0022 123.665Z",
    fill: "#2E3192"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0022 117.153C95.1558 117.153 120.411 91.8977 120.411 60.7441C120.411 29.5905 95.1558 4.33549 64.0022 4.33549C32.8486 4.33549 7.59357 29.5905 7.59357 60.7441C7.59357 91.8977 32.8486 117.153 64.0022 117.153Z",
    fill: "url(#paint0_linear_869_2618)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M115.831 68.3376C113.216 93.3075 91.0067 112.813 63.9979 112.813C36.989 112.813 14.7836 93.3118 12.1694 68.3376C17.4278 88.3453 38.6374 103.309 64.0022 103.309C89.3669 103.309 110.572 88.3496 115.835 68.3376H115.831Z",
    fill: "url(#paint1_linear_869_2618)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.067 60.7441C107.451 60.8342 96.9089 56.2927 96.9089 47.1281C96.9089 37.9634 88.9462 17.3548 63.9978 17.2776C38.5172 17.2003 17.2132 32.5291 11.929 52.9187C14.5561 27.4681 36.8645 7.58496 63.9978 7.58496C91.1311 7.58496 114.981 30.3656 116.067 60.7398V60.7441Z",
    fill: "url(#paint2_linear_869_2618)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.8,
    d: "M64.0022 123.665C96.9528 123.665 123.665 96.9528 123.665 64.0022C123.665 31.0515 96.9528 4.33978 64.0022 4.33978C31.0515 4.33978 4.33978 31.0515 4.33978 64.0022C4.33978 96.9528 31.0515 123.665 64.0022 123.665Z",
    fill: "url(#paint3_radial_869_2618)"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.9466 42.7067C90.4958 42.7067 90.0623 42.5264 89.7403 42.2088L79.9576 32.426C79.6399 32.1084 79.4597 31.6748 79.4597 31.2198V29.3354C79.4597 28.8847 79.6399 28.4511 79.9576 28.1292L84.9456 23.1412C86.0745 22.0123 87.5726 21.3941 89.1651 21.3941C90.7577 21.3941 92.2601 22.0166 93.3847 23.1412L97.1364 26.8929C98.2611 28.0176 98.8835 29.5114 98.8835 31.1039V33.0828C98.8835 33.1601 98.8792 33.2416 98.8663 33.3189C98.7891 34.7998 98.1752 36.1777 97.1321 37.2208L92.1442 42.2088C91.8222 42.5264 91.393 42.7067 90.938 42.7067H90.9466Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1651 23.0983C90.2554 23.0983 91.35 23.5147 92.1828 24.3474L95.9345 28.0991C96.7673 28.9319 97.1836 30.0179 97.1836 31.1082V33.0828H97.1751C97.1536 34.1431 96.7458 35.199 95.9345 36.0103L90.9465 40.9983L81.1638 31.2155V29.3311L86.1517 24.3431C86.9845 23.5104 88.0748 23.094 89.1694 23.094M89.1694 19.6857C87.1176 19.6857 85.1945 20.4841 83.7436 21.935L78.7557 26.923C78.1161 27.5626 77.7555 28.4297 77.7555 29.3311V31.2155C77.7555 32.1213 78.1161 32.9884 78.7557 33.6237L88.5384 43.4064C89.2038 44.0718 90.0752 44.4066 90.9465 44.4066C91.8179 44.4066 92.6893 44.0718 93.3547 43.4064L98.3426 38.4185C99.6733 37.0878 100.455 35.3407 100.57 33.4605C100.583 33.3361 100.592 33.2073 100.592 33.0785V31.1039C100.592 31.0739 100.592 31.0481 100.592 31.0181C100.566 29.0006 99.7721 27.1118 98.3469 25.6824L94.5952 21.9307C93.1443 20.4798 91.217 19.6814 89.1694 19.6814V19.6857Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3688 84.2845C48.9181 84.2845 48.4845 84.1042 48.1626 83.7866L38.3798 74.0038C38.0622 73.6819 37.8819 73.2526 37.8819 72.7976V70.9175C37.8819 70.4668 38.0622 70.0332 38.3798 69.7113L75.7337 32.3574C76.0557 32.0397 76.4849 31.8594 76.9399 31.8594C77.395 31.8594 77.8242 32.0397 78.1462 32.3574L87.9289 42.1401C88.2466 42.4578 88.4268 42.8913 88.4268 43.3463V45.2308C88.4268 45.6815 88.2466 46.115 87.9289 46.437L50.575 83.7909C50.2574 84.1085 49.8238 84.2888 49.3688 84.2888V84.2845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9399 33.5636L86.7227 43.3463V45.2308L49.3688 82.5847L39.586 72.8019V70.9175L76.9399 33.5636ZM76.9399 30.1553C76.0342 30.1553 75.1671 30.5158 74.5318 31.1554L37.1779 68.5093C36.5383 69.1489 36.1777 70.016 36.1777 70.9175V72.8019C36.1777 73.7076 36.5383 74.5747 37.1779 75.21L46.9607 84.9928C47.626 85.6581 48.4974 85.993 49.3688 85.993C50.2402 85.993 51.1116 85.6581 51.7769 84.9928L89.1308 47.6389C89.7704 46.9993 90.131 46.1322 90.131 45.2308V43.3463C90.131 42.4406 89.7704 41.5735 89.1308 40.9382L79.3481 31.1554C78.7085 30.5158 77.8414 30.1553 76.9399 30.1553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.426 93.0542C30.739 93.0542 29.3225 91.7493 29.1465 90.0967C29.125 89.9936 29.1165 89.8863 29.1165 89.779V87.8817C29.1165 87.8001 29.1207 87.7229 29.1336 87.6456C29.1508 87.3194 29.2152 87.0146 29.3225 86.7184L33.7653 74.5576C33.9671 74.0124 34.4306 73.6046 34.9973 73.4801C35.1175 73.4544 35.2419 73.4415 35.3664 73.4415C35.8129 73.4415 36.2464 73.6175 36.5726 73.9394L46.3554 83.7222C46.673 84.0441 46.8533 84.4734 46.8533 84.9284V86.8128C46.8533 87.5297 46.4069 88.1693 45.733 88.414L33.5721 92.8568C33.203 92.9941 32.8166 93.0628 32.4303 93.0628L32.426 93.0542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3621 75.1413L45.1449 84.9241V86.8085L32.984 91.2513C32.7952 91.32 32.6063 91.3544 32.426 91.3544C31.5632 91.3544 30.8463 90.6375 30.8292 89.779H30.8163V87.886H30.8292C30.8292 87.6971 30.8463 87.5039 30.9193 87.3108L35.3621 75.1499M35.3621 71.7416C35.1174 71.7416 34.8728 71.7674 34.6281 71.8232C33.4906 72.0765 32.5634 72.8878 32.1642 73.9824L27.7214 86.1432C27.5668 86.5682 27.4724 87.0189 27.438 87.4868C27.4209 87.6198 27.4123 87.7529 27.4123 87.8903V89.7876C27.4123 89.985 27.4295 90.1782 27.4638 90.3714C27.7729 92.8396 29.8977 94.7712 32.4303 94.7712C33.0184 94.7712 33.5979 94.6682 34.1602 94.4622L46.321 90.0194C47.6646 89.53 48.5618 88.2508 48.5618 86.8171V84.9327C48.5618 84.027 48.2012 83.1599 47.5616 82.5246L37.7788 72.7418C37.1307 72.0936 36.2636 71.7416 35.3707 71.7416H35.3621Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1638 31.2198V29.3354L97.1837 31.1082V33.0871L81.1638 31.2198Z",
    fill: "url(#paint4_linear_869_2618)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.586 70.9175V72.7976L86.7227 45.2265V43.3463L39.586 70.9175Z",
    fill: "url(#paint5_linear_869_2618)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1449 86.8042V84.9241L30.8163 87.8774V89.7747L45.1449 86.8042Z",
    fill: "url(#paint6_linear_869_2618)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9366 35.4466L39.5842 72.799L49.3669 82.5818L86.7194 45.2293L76.9366 35.4466Z",
    fill: "url(#paint7_linear_869_2618)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9466 41.0026L81.1638 31.2198L86.1518 26.2319C87.8173 24.5663 90.5173 24.5663 92.1828 26.2319L95.9345 29.9836C97.6001 31.6491 97.6001 34.3491 95.9345 36.0146L90.9466 41.0026Z",
    fill: "url(#paint8_linear_869_2618)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0308 91.6162L35.3621 77.0215L45.1449 86.8043L30.5502 92.1356C30.2282 92.2558 29.9106 91.9382 30.0308 91.6162Z",
    fill: "url(#paint9_linear_869_2618)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9379 33.5634L39.5854 70.9158L49.3682 80.6986L86.7207 43.3461L76.9379 33.5634Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9466 39.1224L81.1638 29.3397L86.1518 24.3517C87.8173 22.6862 90.5173 22.6862 92.1828 24.3517L95.9345 28.1034C97.6001 29.7689 97.6001 32.469 95.9345 34.1345L90.9466 39.1224Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0308 89.7318L35.3621 75.1371L45.1449 84.9198L30.5502 90.2512C30.2282 90.3714 29.9106 90.0537 30.0308 89.7318Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_869_2618",
    x1: 64.0022,
    y1: 117.153,
    x2: 64.0022,
    y2: 4.33978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#396AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#3872F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#358AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#31B1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#2BE7CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29FFC6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_869_2618",
    x1: 64.0022,
    y1: 68.3376,
    x2: 64.0022,
    y2: 112.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F998E",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#489993",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F9996",
    stopOpacity: 0.3
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_869_2618",
    x1: 64.0021,
    y1: 60.7484,
    x2: 64.0021,
    y2: 7.59355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F998E",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#79AAA0",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#A2C3BD",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#C3D9D5",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#DDE9E7",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F0F5F4",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#FBFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_869_2618",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.1891 64.0753) scale(59.7295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_869_2618",
    x1: 81.1638,
    y1: 31.2112,
    x2: 97.1837,
    y2: 31.2112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_869_2618",
    x1: 39.586,
    y1: 58.0698,
    x2: 86.7227,
    y2: 58.0698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_869_2618",
    x1: 30.8163,
    y1: 87.3494,
    x2: 45.1449,
    y2: 87.3494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_869_2618",
    x1: 39.5838,
    y1: 59.0145,
    x2: 86.7205,
    y2: 59.0145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_869_2618",
    x1: -0.00000173947,
    y1: 32.9927,
    x2: 97.1837,
    y2: 32.9927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_869_2618",
    x1: 30.005,
    y1: 84.5936,
    x2: 45.1449,
    y2: 84.5936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_869_2618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWStoreEditLocationIcon);
export default __webpack_public_path__ + "static/media/WStore_Edit_Location_Icon.6e02528e.svg";
export { ForwardRef as ReactComponent };